export const GET_WORKERS = 'GET_WORKERS';
export const WORKER_REQUEST = 'WORKER_REQUEST';
export const CREATE_WORKER = 'CREATE_WORKER';
export const UPDATE_WORKER = 'UPDATE_WORKER';
export const DELETE_WORKER = 'DELETE_WORKER';
export const WORKER_REQUEST_FAILURE = 'WORKER_REQUEST_FAILURE';
export const KARIGAR_WORKER_REQUEST = 'KARIGAR_WORKER_REQUEST';
export const GET_KARIGAR_WORKERS = 'GET_KARIGAR_WORKERS';
export const KARIGAR_WORKER_REQUEST_FAILURE = 'KARIGAR_WORKER_REQUEST_FAILURE';